import earthfest1 from '../images/2017Earthfest1.jpg';
import earthfest2 from '../images/2017Earthfest2.jpg';
import earthfest3 from '../images/2017Earthfest3.jpg';
import earthfest4 from '../images/2017Earthfest4.jpg';
import atFullMoon from '../images/at full moon.jpg';
import kuma1 from '../images/Kuma 1.1.jpg';
import kuma2 from '../images/Kuma 1.2.jpg';
import kuma3 from '../images/Kuma 2.jpg';
import mansion from '../images/Mansion.jpg';
import organik1 from '../images/Organik 1.jpg';
import organik2 from '../images/Organik 2.jpg';
import sayingGoodBye1 from '../images/saying goodbye1.jpg';
import sayingGoodBye2 from '../images/saying goodbye2.jpg';
import sayingGoodBye3 from '../images/saying goodbye3.jpg';
import storyOfOne1 from '../images/story of one A.jpg';
import storyOfOne2 from '../images/story of one B.jpg';
import journeyThroughTheWoods from '../images/The journey through the woods.jpg';


export default  [
    {
        src: earthfest1,
        alt: 'Earthfest'
    },
    {
        src: earthfest2,
        alt: 'Earthfest'
    },
    {
        src: earthfest3,
        alt: 'Earthfest'
    },
    {
        src: earthfest4,
        alt: 'Earthfest'
    },
    {
        src: atFullMoon,
        alt: 'At Fullmoon'
    },
    {
        src: kuma1,
        alt: 'Kuma'
    },
    {
        src: kuma2,
        alt: 'Kuma'
    },
    {
        src: kuma3,
        alt: 'Kuma'
    }
];

export const all = [
    {
        src: storyOfOne1,
        alt: 'Story of One'
    },
    {
        src: storyOfOne2,
        alt: 'Story of One'
    },
    {
        src: sayingGoodBye1,
        alt: 'Saying goodbye'
    },
    {
        src: sayingGoodBye2,
        alt: 'Saying goodbye'
    },
    {
        src: sayingGoodBye3,
        alt: 'Saying goodbye'
    },
    {
        src: organik1,
        alt: 'Organik'
    },
    {
        src: organik2,
        alt: 'Organik'
    },
    {
        src: earthfest1,
        alt: 'Earthfest'
    },
    {
        src: earthfest2,
        alt: 'Earthfest'
    },
    {
        src: earthfest3,
        alt: 'Earthfest'
    },
    {
        src: earthfest4,
        alt: 'Earthfest'
    },
    {
        src: atFullMoon,
        alt: 'At Fullmoon'
    },
    {
        src: kuma1,
        alt: 'Kuma'
    },
    {
        src: kuma2,
        alt: 'Kuma'
    },
    {
        src: kuma3,
        alt: 'Kuma'
    },
    {
        src: mansion,
        alt: 'Mansion'
    },
    {
        src: journeyThroughTheWoods,
        alt: 'The journey through the woods'
    }
]
